/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdminService } from './services/admin.service';
import { AenderungsantragService } from './services/aenderungsantrag.service';
import { AiService } from './services/ai.service';
import { AnfrageService } from './services/anfrage.service';
import { AnredeService } from './services/anrede.service';
import { AntwortService } from './services/antwort.service';
import { AusschreibungService } from './services/ausschreibung.service';
import { AuthenticationService } from './services/authentication.service';
import { CountryService } from './services/country.service';
import { DocumentService } from './services/document.service';
import { FoerderprogrammService } from './services/foerderprogramm.service';
import { GutachtenService } from './services/gutachten.service';
import { InfotextService } from './services/infotext.service';
import { MitantragstellerService } from './services/mitantragsteller.service';
import { NachrichtService } from './services/nachricht.service';
import { PhaseService } from './services/phase.service';
import { PortalkonfigurationService } from './services/portalkonfiguration.service';
import { PortalzugriffService } from './services/portalzugriff.service';
import { PostleitzahlzuordnungService } from './services/postleitzahlzuordnung.service';
import { ProjektbeteiligterService } from './services/projektbeteiligter.service';
import { RuntimeEnumService } from './services/runtime-enum.service';
import { TitelService } from './services/titel.service';
import { UserService } from './services/user.service';
import { UserSettingsService } from './services/user-settings.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdminService,
    AenderungsantragService,
    AiService,
    AnfrageService,
    AnredeService,
    AntwortService,
    AusschreibungService,
    AuthenticationService,
    CountryService,
    DocumentService,
    FoerderprogrammService,
    GutachtenService,
    InfotextService,
    MitantragstellerService,
    NachrichtService,
    PhaseService,
    PortalkonfigurationService,
    PortalzugriffService,
    PostleitzahlzuordnungService,
    ProjektbeteiligterService,
    RuntimeEnumService,
    TitelService,
    UserService,
    UserSettingsService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
